import Link from './Link';


export const linkComponentDecorator = {
  strategy: (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(
      (character) => {
        const entityKey = character.getEntity();
        return (
          entityKey !== null &&
          contentState.getEntity(entityKey).getType() === 'LINK'
        );
      },
      callback,
    );
  },
  component: Link
};



// WEBPACK FOOTER //
// ./src/blocks/LinkRenderComponent.js